<script>
  import { Label, Input } from "sveltestrap";
  import { data, dataInfo } from "../../editor/storage.js";
  import Table from "./table.svelte";
  import { evalExpression } from "../../fronto/utility.js";
  import { getPreviewData } from "../../editor/component/data.js";
  export let closer;
  export let inputBlurAction;
  export let inputFocusAction;
  export let subTitle;
  export let changeAction;
  export let value;
  export let field;
  export let values;
  let exprValue = value || "(datum.value)";
  let previewData = getPreviewData($data, 20);
  let expressionPreview = values?.[0] || previewData[0][field];
  let expressionForm, isProcessing;
  let groupBy = false;
  function updatePreview(event) {
    expressionPreview = "processing...";
    isProcessing = true;
    let datumValue = values?.[0] || previewData[0][field];
    let expression = event.target.value;
    let evalExpr = expression.replace(
      /datum\.value/g,
      typeof datumValue == "string" ? "'" + datumValue + "'" : datumValue
    );
    evalExpr = evalExpr.replace(/(datum\.index)/g, 0);
    evalExpr = evalExpr.replace(/(datum)/g, JSON.stringify(previewData[0]));
    if (!evalExpr.startsWith("(")) evalExpr = "(" + evalExpr + ")";
    let config = { datatype: $dataInfo.stats };
    let evaled = evalExpression(
      evalExpr,
      field,
      datumValue,
      previewData,
      groupBy,
      config
    );
    expressionPreview = evaled;
    isProcessing = false;
  }
  function insertToExpression(v, v2) {
    if (expressionForm?.selectionStart !== undefined) {
      let ps = expressionForm.selectionStart;
      let pe = expressionForm.selectionEnd;
      if (v2) {
        exprValue =
          exprValue.substring(0, ps) +
          v +
          exprValue.substring(ps, pe || ps) +
          v2 +
          exprValue.substring(pe || ps, exprValue.length);
      } else {
        exprValue =
          exprValue.substring(0, ps) +
          v +
          exprValue.substring(pe || ps, exprValue.length);
      }
    } else {
      exprValue += v;
    }
    expressionForm?.focus();
  }
</script>

<div class="window-background">
  <div class="window">
    <div class="window-header">
      <h3>
        Edit data expression{subTitle ? " for " + subTitle : ""} / Reference field:
        <code>{field}</code>
      </h3>
      <button type="button" on:click={closer}>
        <i class="bi bi-x" alt="cancel" />
      </button>
    </div>
    <div class="window-body">
      <p class="text-sm mb-2 px-3">
        Double-click data fields and operators to insert them in the experssion.
        An expression should be encapsulated by parentheses "()".
      </p>
      <div class="columns">
        <!-- data preview -->
        <div class="section-data-preview">
          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label>Data points (datum.X)</Label>
            </div>
            <div class="dupo-menu-pane-row">
              <div
                class="form-style py-2"
                style="height: 3rem; overflow-y: scroll"
              >
                {#each $dataInfo.columns as c}
                  <!-- <div class="column-name-wrap"> -->
                  <span
                    class="column-name"
                    on:dblclick={() => {
                      insertToExpression(`datum.${c}`);
                    }}
                  >
                    {c}
                  </span>
                  <!-- </div> -->
                {/each}
              </div>
            </div>
          </div>
          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label>Data fields ("X")</Label>
            </div>
            <div class="dupo-menu-pane-row">
              <div
                class="form-style py-2"
                style="height: 3rem; overflow-y: scroll"
              >
                {#each $dataInfo.columns as c}
                  <!-- <div class="column-name-wrap"> -->
                  <span
                    class="field-name"
                    on:dblclick={() => {
                      insertToExpression(`"${c}"`);
                    }}
                  >
                    {c}
                  </span>
                  <!-- </div> -->
                {/each}
              </div>
            </div>
          </div>
          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-row">
              <Label>Data preview</Label>
            </div>
            <div class="dupo-menu-pane-row">
              <div class="data-previewer form-style">
                <Table
                  tableData={previewData}
                  tableColumns={$dataInfo.columns}
                />
              </div>
            </div>
          </div>
        </div>
        <!-- main -->
        <div class="section-main">
          <div class="dupo-menu-pane" style="height: 19rem;">
            <div class="dupo-menu-pane-row">
              <Label for="_expression">Expression</Label>
            </div>
            <div class="dupo-menu-pane-form-row">
              <textarea
                type="textarea"
                class="custom-form-select"
                name="_expression"
                id="_expression"
                style="height: 17.5rem;"
                bind:this={expressionForm}
                bind:value={exprValue}
                on:focus={(event) => {
                  inputFocusAction(event);
                  updatePreview(event);
                }}
                on:blur={inputBlurAction}
                on:keyup={(event) => {
                  updatePreview(event);
                }}
              />
            </div>
          </div>

          <div class="dupo-menu-pane mt-2">
            <div class="dupo-menu-pane-row">
              <Label for="_expression">Expression preview</Label>
            </div>
            <div
              class="dupo-menu-pane-row pt-1"
              style="height: 8rem; overflow-y: hidden;"
            >
              <span class={"preview" + (isProcessing ? " processing" : "")}
                >{expressionPreview}</span
              >
            </div>
          </div>
        </div>
        <!-- operators -->
        <div class="section-operators">
          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label>Operators</Label>
            </div>
            <div class="dupo-menu-pane-row">
              <div
                class="form-style pt-2"
                style="height: 22rem; overflow-y: scroll;"
              >
                <!-- simple text -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression("' '");
                    }}>'text'</span
                  ><span class="operator-desc">Simple text.</span>
                </div>

                <!-- concatenation -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(" + ");
                    }}>+</span
                  ><span class="operator-desc">String concatenation.</span>
                </div>

                <!-- round -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression("round(", " ,0)");
                    }}>round(n, d)</span
                  ><span class="operator-desc"
                    >Round <code>n</code> at <code>10<sup>d</sup></code>.</span
                  >
                </div>

                <!-- format -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression("format(", ", ',d')");
                    }}>format(n, f)</span
                  ><span class="operator-desc"
                    >Format <code>n</code> in <code>f</code>.
                    <a
                      href="https://observablehq.com/@d3/d3-format"
                      target="_blank">Format string?</a
                    ></span
                  >
                </div>

                <!-- format -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression("timeFormat(", ", '')");
                    }}>timeFormat(n, f)</span
                  ><span class="operator-desc"
                    >Time format <code>n</code> in <code>f</code>.
                    <a
                      href="https://github.com/d3/d3-time-format"
                      target="_blank">TimeFormat string?</a
                    ></span
                  >
                </div>

                <!-- sum -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(`sum("${field || "field"}", groupBy)`);
                    }}>sum(field, groupBy)</span
                  ><span class="operator-desc"
                    >Sum the values of the <code>field</code>. Provide a field
                    name as a string value (double-click from the field names).
                    If
                    <code>groupBy = true</code>, then it sums by data groups of
                    the label value.
                  </span>
                </div>

                <!-- count -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `count("${field || "field"}", groupBy)`
                      );
                    }}>round(field, groupBy)</span
                  ><span class="operator-desc"
                    >Count the data points of the <code>field</code>.
                    <code>groupBy</code> can be a field name to specify how to do
                    group-by.</span
                  >
                </div>

                <!-- mean -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `mean("${field || "field"}", groupBy)`
                      );
                    }}>mean(field, groupBy)</span
                  ><span class="operator-desc"
                    >Average the values of the <code>field</code>.</span
                  >
                </div>

                <!-- median -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `median("${field || "field"}", groupBy)`
                      );
                    }}>median(field, groupBy)</span
                  ><span class="operator-desc"
                    >Get the median of the values of the <code>field</code
                    >.</span
                  >
                </div>

                <!-- max -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(`max("${field || "field"}", groupBy)`);
                    }}>max(field, groupBy)</span
                  ><span class="operator-desc"
                    >Get the maximum value of the <code>field</code>.</span
                  >
                </div>

                <!-- min -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(`min("${field || "field"}", groupBy)`);
                    }}>min(field, groupBy)</span
                  ><span class="operator-desc"
                    >Get the minimum value of the <code>field</code>.</span
                  >
                </div>

                <!-- argmax -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `argmax("${field || "field"}", "argField")`
                      );
                    }}>argmax(field, argField)</span
                  ><span class="operator-desc"
                    >Get the value of <code>argField</code> of the datum with
                    the maximum value of the <code>field</code>.
                  </span>
                </div>

                <!-- argmin -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `argmin("${field || "field"}", "argField")`
                      );
                    }}>argmin(field, argField)</span
                  ><span class="operator-desc"
                    >Get the value of <code>argField</code> of the datum with
                    the minimum value of the <code>field</code>.
                  </span>
                </div>

                <!-- isFirst -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `isFirst("${field || "field"}", datum)`
                      );
                    }}>isFirst(field, datum)</span
                  ><span class="operator-desc"
                    >Get wether the <code>datum</code> (the current value; must
                    not be changed) is the first value when sorted by
                    <code>field</code> in a natural order.</span
                  >
                </div>

                <!-- isLast -->
                <div class="operator-wrap">
                  <span
                    class="operator"
                    on:click={() => {
                      insertToExpression(
                        `isLast("${field || "field"}", datum)`
                      );
                    }}>isLast(field, datum)</span
                  ><span class="operator-desc"
                    >Get wether the <code>datum</code> (the current value; must
                    not be changed) is the last value when sorted by
                    <code>field</code> in a natural order.</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="dupo-menu-pane">
            <div class="dupo-menu-pane-form-row form-inline">
              <Input
                type="checkbox"
                name="groupby"
                id="groupby"
                bind:checked={groupBy}
              />
              <Label for="groupby">Auto-group-by</Label>
              <span class="operator-desc"
                >If group-by is set true, then applicable operations are done by
                groups of each label value.</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="pane-divider" />

      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-button-row">
          <button
            type="button"
            on:click={(event) => {
              changeAction({ target: { value: exprValue } });
              closer();
            }}><i class="bi bi-check-lg me-1" /> Confirm</button
          >
          <button type="button" on:click={closer}
            ><i class="bi bi-x-lg me-1" /> Cancel</button
          >
        </div>
      </div>
    </div>
  </div>
</div>

<style>
  .window-background {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 999;
  }
  .window {
    position: absolute;
    top: 120px;
    left: 50%;
    transform: translateX(-50%);
    width: 95vw;
    max-width: 1000px;
    height: auto;
    background-color: white;
    border: 1px solid #dddddd;
    border-radius: var(--default-radius);
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1), 0 7px 25px rgba(0, 0, 0, 0.1);
  }
  .window-header {
    display: flex;
    justify-content: space-between;
    padding: 1rem 2rem 0 2rem;
  }
  .window-header h3 {
    font-size: 1rem;
    color: #454545;
    margin: 0;
    padding: 0;
    user-select: none;
  }
  .window-header button {
    appearance: none;
    padding: 0;
    margin: 0;
    border: 0;
    font-size: 1rem;
    background: transparent;
  }
  .window-body {
    padding: 1rem;
  }

  .columns {
    display: flex;
    flex-wrap: wrap;
  }
  .section-data-preview {
    width: 37%;
  }
  .section-main {
    width: 38%;
  }
  .section-operators {
    width: 25%;
  }
  .data-previewer {
    height: 17.5rem;
    overflow-y: scroll;
  }
  .form-style {
    width: calc(100% + 1rem);
    padding: 0.2rem 0.5rem;
    margin: 0 -0.5rem;
    border-radius: var(--default-radius);
    background-color: white;
    border: 1px solid #dddddd;
    font-size: 0.8rem;
  }
  .column-name {
    display: inline-block;
    color: #454545;
    background-color: #f5f5f5;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
    margin: 0 0.5rem 0.25rem 0;
    font-size: 0.72rem;
    font-family: var(--bs-font-monospace);
  }
  .column-name:hover {
    color: #09af00;
    background-color: #defabb;
  }
  .field-name {
    display: inline-block;
    color: #454545;
    background-color: #f5f5f5;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
    margin: 0 0.5rem 0.25rem 0;
    font-size: 0.72rem;
    font-family: var(--bs-font-monospace);
  }
  .field-name:hover {
    color: #009aa1;
    background-color: #dff8f8;
  }
  .operator-wrap {
    margin: 0 0 0.5rem 0;
  }
  .operator {
    display: inline;
    color: #454545;
    background-color: #f5f5f5;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
    margin: 0 0.5rem 0.25rem 0;
    font-size: 0.72rem;
    font-family: var(--bs-font-monospace);
  }
  .operator:hover {
    color: #f47100;
    background-color: #fff2df;
  }
  .operator-desc {
    display: inline-block;
    font-size: 0.7rem;
    margin: 0 0.5rem 0.25rem 0;
  }
  .preview {
    display: inline;
    color: #1945cf;
    background-color: #e2f3ff;
    padding: 0.2rem 0.5rem;
    border-radius: var(--default-radius);
  }
  .preview.processing {
    color: #454545;
    background-color: #f5f5f5;
  }
</style>
